import React from "react";

export default function PastExecutiveCommitteesTableComponent({
  pastCommittees,
}) {
  return (
    <section
      className="mb-5"
      style={{ backgroundColor: "#fff" }}
      data-aos="fade-left"
      id="past-executive-committees"
    >
      <div className="rounded-3 border-vcg-muted p-4">
        <h4 className="fw-bold mb-4">Recent Executive Committees</h4>

        <div className="table-responsive">
          <table className="table table-hover align-middle">
            {/* Table Header */}
            <thead className="table-dark">
              <tr>
                <th>Executive Committee</th>
                <th>President</th>
                <th>Active President</th>
                <th>Joint Secretary</th>
                <th>Joint Secretary</th>
              </tr>
            </thead>

            {/* Table Rows */}
            <tbody>
              {pastCommittees.map((committee, idx) => {
                const jointSecretaries = committee.jointSecretaries || [];

                return (
                  <tr key={idx}>
                    <td className="fw-semibold">{committee.name}</td>

                    <td>{committee.president || "—"}</td>

                    <td>{committee.activePresident || "—"}</td>

                    <td>{jointSecretaries[0] || "—"}</td>

                    <td>{jointSecretaries[1] || "—"}</td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>
    </section>
  );
}
